import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';
import styled from '@emotion/styled';

const ButtonAnswer = ({ isLoading, onSubmit }) => {
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
  `;
  return (
    <div className="d-flex justify-content-center mt-1">
      <Stylescal>
        <Button.Ripple
          className="round"
          color="danger"
          onClick={onSubmit}
          disabled={isLoading}
        >
          Answer
        </Button.Ripple>
      </Stylescal>
    </div>
  );
};
ButtonAnswer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ButtonAnswer;
